<template>
  <div class="login-container">
<TopBar color="#000" :login="true" signUp="#0D53FF" loginColor="#A3AAB7" :imgsrc="logo1"/>
<div class="login-img">

</div>
<div class="login-content">
<div class="content-input-box">
  <div class="title">
  <span>Hello!</span><span>欢迎登录</span>
</div>
<div class="input-list">
  <div class="input-list-item">
    <img :src="phone" alt="">
    <input type="text" placeholder="请输入手机号" v-model="username">
  </div>
   <div class="input-list-item">
    <img :src="password" alt="" >
    <input type="password" placeholder="请输入登录密码" v-model="passWord">
  </div>
</div>
<div class="checkBox">
  <input type="checkbox" id="CheckBox" v-model="istrue">
  <label for="CheckBox">记住登录状态</label>
</div>

<div class="btn-submit" @click="handlelogin">
  登录
</div>
<div class="routerpush">
  <div class="signup">
    <p>没有账号?立即</p><span>注册</span>
  </div>
  <div class="setpassword">
    忘记密码
  </div>
</div>
</div>
</div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import phone from "@/assets1/登录_slices/删除备份 3@3x.png"
import password from "@/assets1/登录_slices/删除备份@3x.png"
import TopBar from "@/views/supermarket/TopBar"
import logo1 from "@/assets1/logo_slices/编组 2.png"
import {Login} from "@/api/user"
export default {
components:{
  TopBar
},
data(){
//   const res=await Login({
//       login_type: 2,
//       username: "Alex3",
//       password: "654321"
// })
  return{
    logo1,
    phone,password,
    username:'',passWord:'',
    istrue:false
  }
  
},methods:{
 async handlelogin(){
  const res=  await Login({
        login_type: 2,
      username: this.username,
      password: this.passWord })
Message({
          message: '登录成功',
          type: 'success'
        });

        
        this.$store.commit('setUid',res.user_id)
if(this.istrue){
  localStorage.setItem('token',`Bearer ${res.access_token}`)
}else{
  sessionStorage.setItem('token',`Bearer ${res.access_token}`)
}

      this.$router.push('/dataset')
  }
}
}
</script>

<style scoped>
.setpassword{
    font-family: Regular;
  color: #3D79EC;
}
.signup{
  display: flex;
  font-family: Regular;
}
.signup span{
  font-family: Regular;
  color: #3D79EC;
}
.routerpush{
  margin-top: 5px;
  font-size: 12px;
  display: flex;
  color: #999;
  width: 100%;
  justify-content: space-between;
}
.btn-submit{
  margin-top: 41px;
  width: 350px;height: 45px;
  background-color: #0D53FF;
  border-radius: 4px;
  font-size: 16px;
  color: white;
  text-align: center;
  line-height: 45px;
  cursor: pointer;
}
.checkBox label{
  font-size: 12px;
  color: #666;

}
.checkBox input{
margin-right: 8px;
}
.checkBox{
  display: flex;
  height:  16px;
  line-height: 16px;
}
.content-input-box{
  width: 350px;
}
.input-list-item input{
outline: none;
border: none;
  height: 20px;
  padding-left: 16px;
  font-size: 14px;
  width: 85%;
}
.input-list-item img{
  width: 20px;
  object-fit: cover;
  height: 20px;
 
}
.input-list-item{
padding-bottom: 10px;
  width:350px ;
  border-bottom: 1px solid #D6DAE2;
  display: flex;
  margin-bottom: 30px;
}
.title{
  margin-bottom: 100px;
  text-align: center;
}
.login-content{
  display: flex;

  justify-content: center;align-items: center;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.6px;

}
.login-content span:first-child{
  display: inline-block;
width: 107px;
}
.login-content span{
  font-family: Medium;
}
.login-container{
  min-width:1920px;
  min-height: 1080px;
display: flex;
font-family: Regular;
}
.login-img{
width: 817px;
 height: 1080px;
 background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E7%99%BB%E5%BD%95%E9%A1%B5/Group%208.png');
}
.login-content{
 width: 1102px;
 height: 1080px;

}
</style>